import React, {useCallback, useEffect, useRef, useState} from "react";
import {Col, Row, Spin} from "antd";

import BalanceInfoCard from "../../../components/billings/BalanceInfoCard";
import {getAccount} from "../../../helpers/account";
import {messageType, showMessages} from "../../../helpers/message";

const BillingBalancesStaff = ({refreshBalances, toggleRefreshBalances, refreshAccountBalance, isOwner}) => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);

    const [loading, setLoading] = useState(false);
    const [payableBalance, setPayableBalance] = useState(undefined);
    const [overdueBalance, setOverdueBalance] = useState(undefined);
    const [accountingBalance, setAccountingBalance] = useState(undefined);
    const [depositBalance, setDepositBalance] = useState(undefined);
    const dataColSize = isOwner ?
        {
            xs: 24,
            sm: 16,
            md: 12,
            lg: 6
        } :
        {
            xs: 24,
            sm: 16,
            md: 12,
            lg: 8
        };

    const fetchBalances = useCallback(async () => {
        try {
            setLoading(true);
            const signal = abortSignalRef.current;
            const data = await getAccount(signal);
            if (signal.aborted === false) {
                setPayableBalance(Math.max(parseFloat(data.payable_balance), 0));
                setOverdueBalance(Math.max(parseFloat(data.overdue_balance), 0));
                setAccountingBalance(parseFloat(data.accounting_balance));
                setDepositBalance(Math.max(parseFloat(data.deposit_balance), 0));
                refreshAccountBalance(parseFloat(data.accounting_balance));

                setLoading(false);
            }
        } catch (error) {
            showMessages(error.message, messageType.error);
            setLoading(false);
            if(error.status_code === 404) window.location.replace('/404');
        }
    }, [refreshAccountBalance]);

    // Load initial data on mount, and update account balances when refreshBalances is true
    useEffect(() => {
        if (refreshBalances === true) {
            toggleRefreshBalances(false);
        }
        fetchBalances();
    }, [refreshBalances, toggleRefreshBalances, fetchBalances]);

    // Cleanup effect when component unmounts
    useEffect(() => {
        const abortController = abortControllerRef.current;
        return function abort() {
            abortController.abort();
        }
    }, []);

    return <Spin spinning={loading}>
        <Row className="universal-bottom-spacing" gutter={[{xs: 0, md: 16}, 16]}>
            <Col {...dataColSize}>
                <BalanceInfoCard
                    balanceType="payable"
                    balance={payableBalance}
                />
            </Col>
            <Col {...dataColSize}>
                <BalanceInfoCard
                    balanceType="accounting"
                    balance={accountingBalance}
                />
            </Col>
            <Col {...dataColSize}>
                <BalanceInfoCard
                    balanceType="overdue"
                    balance={overdueBalance}
                />
            </Col>
            {isOwner &&
                <Col {...dataColSize}>
                    <BalanceInfoCard
                        balanceType="deposit"
                        balance={depositBalance}
                    />
                </Col>
            }
        </Row>
    </Spin>
}

export default BillingBalancesStaff;
